import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string(),
  cnpj: Yup.string(),
});

export default validationSchema;
